import React from "react";
import { Navigate } from "react-router-dom";
import routes from "../utils/routes";

const Home = () => {
  return <Navigate to={routes.LOGIN} state={{ autoNavigate: true }} replace />;
};

export default Home;
